import { render, staticRenderFns } from "./MyDaftar.vue?vue&type=template&id=3ba4335a&scoped=true&"
import script from "./MyDaftar.vue?vue&type=script&lang=js&"
export * from "./MyDaftar.vue?vue&type=script&lang=js&"
import style0 from "./MyDaftar.vue?vue&type=style&index=0&id=3ba4335a&prod&lang=less&"
import style1 from "./MyDaftar.vue?vue&type=style&index=1&id=3ba4335a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4335a",
  null
  
)

export default component.exports